{
  "AboutPage": {
    "get-listed-description": "Vous souhaitez mettre en valeur votre entreprise sur la plateforme Trust Marketplace ?",
    "get-listed-suffix": "pour commencer.",
    "get-listed-title": "Inscrivez-vous",
    "how-description": "Les commerçants et les particuliers vérifient leur identité, leur inscription d'entreprise et leurs qualifications via la plateforme Raytio. Chaque vérification est signée numériquement et peut faire l'objet d'un audit indépendant, garantissant ainsi une chaîne de confiance transparente.",
    "how-title": "Comment fonctionne la vérification",
    "sign-up": "Inscrivez-vous à Raytio",
    "title": "À propos du marché de la confiance",
    "what-is-description": "La plateforme Raytio Trust Marketplace est un annuaire public de commerçants et de prestataires de services vérifiés. Chaque fiche est sécurisée par une vérification cryptographique, garantissant ainsi l'authenticité et la fiabilité des informations affichées.",
    "what-is-title": "Qu’est-ce que le marché de la confiance ?"
  },
  "BookingPage": {
    "book": "Livre",
    "date-range-label": "Suivant",
    "days-label": "jours",
    "km-away": "{distance} km de distance",
    "location-label": "Emplacement",
    "location-placeholder": "Saisissez le nom de la banlieue ou de la ville...",
    "no-results": "Aucun rendez-vous disponible. Essayez d'élargir votre zone de recherche ou votre période.",
    "progress": "Recherche effectuée sur un total de fournisseurs",
    "radius-label": "Dans",
    "search": "Recherche",
    "search-failed": "La recherche a échoué. Veuillez réessayer.",
    "search-timed-out": "La recherche a expiré. Certains fournisseurs n'ont peut-être pas répondu.",
    "searching": "Recherche de fournisseurs...",
    "service-label": "Service",
    "service-placeholder": "Sélectionnez un service...",
    "sign-in-prompt": "Connectez-vous avec votre compte Raytio pour rechercher les rendez-vous disponibles.",
    "sign-in-to-search": "Connectez-vous pour effectuer une recherche",
    "sort-closest": "Le plus proche",
    "sort-provider": "Par fournisseur",
    "sort-soonest": "le plus tôt",
    "title": "Prendre rendez-vous",
    "location-permission-denied": "L'autorisation de localisation a été refusée. Veuillez saisir une adresse à la place.",
    "location-unavailable": "Impossible de déterminer votre position. Veuillez saisir une adresse à la place.",
    "my-location": "Ma position",
    "use-my-location": "Utilisez ma localisation",
    "sign-up-prompt": "Vous n'avez pas de compte ? Inscrivez-vous pour rechercher des rendez-vous disponibles.",
    "sign-up-to-search": "Inscrivez-vous pour rechercher",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "CategoryFilter": {
    "clear": "Clear",
    "no-results": "No categories found",
    "placeholder": "Filter by category…"
  },
  "CountryFilter": {
    "all-countries": "Tous les pays",
    "filter-by-country": "Filtrer par pays"
  },
  "CtaBar": {
    "book": "Livre",
    "coming-soon": "À venir"
  },
  "Footer": {
    "about": "À propos",
    "powered-by": "Alimenté par",
    "privacy": "Confidentialité",
    "terms": "Termes"
  },
  "Header": {
    "about": "À propos",
    "brand": "Marché Raytio",
    "merchants": "Marchands",
    "services": "Services",
    "sign-in": "Se connecter",
    "sign-out": "se déconnecter",
    "sign-up": "S'inscrire"
  },
  "HomePage": {
    "subtitle": "Découvrez des commerçants vérifiés et des prestataires de services de confiance.",
    "title": "Trust Marketplace",
    "verified-merchants": "Commerçants vérifiés",
    "view-all": "Afficher tout"
  },
  "MerchantCard": {
    "unnamed": "Marchand anonyme",
    "verified": "Vérifié"
  },
  "MerchantDetail": {
    "active": "Actif",
    "approved": "Approuvé",
    "default-description": "Consultez ce marchand sur la plateforme Raytio Trust Marketplace.",
    "forms-heading": "Formulaires",
    "forms-sign-in-button": "Connectez-vous pour consulter les formulaires",
    "forms-sign-in-prompt": "Connectez-vous avec votre compte Raytio pour consulter les formulaires de ce commerçant.",
    "locations": "Lieux",
    "no-address": "Adresse indisponible",
    "no-forms-available": "Aucun formulaire disponible",
    "not-found": "Commerçant introuvable",
    "primary-use": "Primaire",
    "sign-in-prompt": "Connectez-vous avec votre compte Raytio pour consulter les détails et l'emplacement des succursales de ce commerçant.",
    "sign-in-to-view": "Connectez-vous pour voir les emplacements",
    "unnamed": "Marchand anonyme",
    "forms-sign-up-button": "Inscrivez-vous pour voir les formulaires",
    "forms-sign-up-prompt": "Vous n'avez pas de compte ? Inscrivez-vous pour accéder aux formulaires de ce commerçant."
  },
  "MerchantsPage": {
    "no-merchants": "Aucun marchand trouvé.",
    "subtitle": "Consultez la liste des marchands vérifiés et des prestataires de services de confiance.",
    "title": "Annuaire des commerçants"
  },
  "SearchBar": {
    "placeholder": "Rechercher des marchands..."
  },
  "ServiceCategoryFilter": {
    "no-results": "Aucune catégorie trouvée",
    "placeholder": "Accéder à une catégorie de service…"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "Services",
    "no-merchants": "Aucun fournisseur n'a été trouvé pour ce service.",
    "not-found": "Service introuvable",
    "search-placeholder": "Fournisseurs de recherche...",
    "sign-in-prompt": "Connectez-vous avec votre compte Raytio pour voir les fournisseurs de ce service.",
    "sign-in-to-view": "Connectez-vous pour consulter les prestataires",
    "sign-up-prompt": "Vous n'avez pas de compte ? Inscrivez-vous pour voir les prestataires de ce service.",
    "sign-up-to-view": "Inscrivez-vous pour voir les prestataires"
  },
  "ServiceItemAttributes": {
    "no-data": "Aucune donnée d'attribut disponible."
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "Services",
    "hide-details": "Masquer les détails",
    "items-title": "Produits et services",
    "no-items": "Aucun produit ni service répertorié.",
    "not-found": "Introuvable",
    "show-details": "Afficher les détails"
  },
  "ServicesPage": {
    "no-services": "Aucun service disponible.",
    "services-count": "{count, plural, one {# service} other {# services}}",
    "subtitle": "Parcourez les services par catégorie.",
    "title": "Services"
  },
  "ThemeToggle": {
    "dark-mode": "Passer en mode sombre",
    "light-mode": "Passer en mode clair"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "Données signées",
    "signature": "Signature",
    "signing-key": "Clé de signature",
    "verify": "Vérifier la signature",
    "verifying": "Vérification…",
    "verify-valid": "Signature valide",
    "verify-invalid": "La signature ne correspond pas",
    "verify-no-key": "Aucune clé de signature enregistrée — vérification impossible",
    "verify-error": "Impossible de récupérer la clé de signature",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  },
  "BuyPage": {
    "title": "Choisissez votre session",
    "slot-label": "Emplacement {slotNumber}",
    "choose-duration": "Sélectionnez une durée",
    "in-use-title": "Cet emplacement est occupé",
    "in-use-body": "Cet emplacement a actuellement une session active. Veuillez réessayer dans quelques instants.",
    "halted-title": "Achat en cours",
    "halted-body": "Quelqu'un est en train de finaliser un achat pour cet emplacement. Veuillez patienter un instant et réessayer.",
    "no-options": "Aucune option n'est disponible pour cet emplacement."
  }
}
